module.exports = __webpack_public_path__ + "img/03.f9cf315a.jpg";